import React, { useState, useContext } from 'react';
import { View, Text, TextInput, TouchableOpacity, ActivityIndicator, StyleSheet } from 'react-native';
import { Platform } from 'react-native';
import { useAuth } from '../contexts/AuthContext';

// Import NavigationContext properly for web
let NavigationContext: React.Context<any> | undefined;
if (Platform.OS === 'web') {
  try {
    NavigationContext = require('../AppNavigator.web').NavigationContext;
  } catch (error) {
    console.warn('Failed to import NavigationContext:', error);
  }
}

export default function SignupScreen({ navigation }: { navigation?: any }) {
  // Use platform-specific navigation
  let webNavigation = null;
  try {
    if (Platform.OS === 'web' && NavigationContext) {
      webNavigation = useContext(NavigationContext);
    }
  } catch (error) {
    console.warn('Error accessing NavigationContext:', error);
  }
  const { signUp, loading } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [phone, setPhone] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  const handleSignup = async () => {
    setSubmitting(true);
    setError(null);
    const { error } = await signUp(email, password, phone);
    if (error) setError(error.message);
    setSubmitting(false);
  };

  return (
    <View style={styles.container}>
      <Text style={styles.title}>Sign Up</Text>
      <TextInput
        style={styles.input}
        placeholder="Email"
        autoCapitalize="none"
        keyboardType="email-address"
        value={email}
        onChangeText={setEmail}
        placeholderTextColor="#888"
      />
      <TextInput
        style={styles.input}
        placeholder="Password"
        secureTextEntry
        value={password}
        onChangeText={setPassword}
        placeholderTextColor="#888"
      />
      <TextInput
        style={styles.input}
        placeholder="Phone Number (optional)"
        keyboardType="phone-pad"
        value={phone}
        onChangeText={setPhone}
        placeholderTextColor="#888"
      />
      {error && <Text style={styles.error}>{error}</Text>}
      <TouchableOpacity
        style={styles.button}
        onPress={handleSignup}
        disabled={submitting || loading}
      >
        {submitting ? <ActivityIndicator color="#3B5323" /> : <Text style={styles.buttonText}>Sign Up</Text>}
      </TouchableOpacity>
      <TouchableOpacity onPress={() => {
        // For web navigation
        if (Platform.OS === 'web') {
          window.dispatchEvent(new CustomEvent('navigate', {
            detail: { screen: 'Login' }
          }));
        } else {
          // For native navigation
          navigation?.navigate('Login');
        }
      }}>
        <Text style={styles.link}>Already have an account? Login</Text>
      </TouchableOpacity>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#3B5323',
    paddingHorizontal: 24,
  },
  title: {
    color: 'white',
    fontSize: 28,
    fontWeight: 'bold',
    marginBottom: 32,
  },
  input: {
    backgroundColor: 'white',
    borderRadius: 8,
    marginBottom: 16,
    paddingHorizontal: 16,
    paddingVertical: 12,
    width: 320,
    maxWidth: '100%',
  },
  error: {
    color: '#f87171',
    marginBottom: 8,
  },
  button: {
    backgroundColor: 'white',
    borderRadius: 8,
    paddingHorizontal: 24,
    paddingVertical: 12,
    marginBottom: 8,
    width: 320,
    maxWidth: '100%',
    alignItems: 'center',
  },
  buttonText: {
    color: '#3B5323',
    fontWeight: 'bold',
    fontSize: 16,
  },
  link: {
    color: 'white',
    textDecorationLine: 'underline',
    marginTop: 12,
    fontSize: 16,
  },
});
